import React from 'react';

const RolePermissionCard = ({ role, color = "black", permissions }) => {
  return (
    <div className="mb-2 p-2 border-start border-3 border-brown bg-white">
      <p className="fw-bold mb-1" style={{ fontSize: '13px', color: color }}>
        *{role} can
      </p>
      <ul className="ps-3 mb-1" style={{ fontSize: '12.5px' }}>
        {permissions.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default RolePermissionCard;
